
export const SuccessMessage = async (message) => {
  return await message;
};

export const ErrorMessage = async (message) => {
  return await message;
};